import { handoffUrlFor } from "@/lib/auth/handoff";
import { useSessionHint } from "@/lib/auth/session-hint";

/** Public navigation stays Clerk-free; authentication happens after entry. */
export default function WorkspaceLink({
  className,
  signedOutLabel = "Sign in",
}: {
  className?: string;
  signedOutLabel?: string;
}) {
  const signedIn = useSessionHint();
  const destination = new URL("/", typeof window === "undefined" ? "https://manticscore.com" : window.location.origin).href;
  return (
    <a href={signedIn ? "/" : handoffUrlFor(destination)} className={className}>
      {signedIn ? "Open workspace" : signedOutLabel}
    </a>
  );
}
